module.exports = __webpack_public_path__ + "49c807d2ad016120d36df54eed2f9b35.jpg";